// Single source of truth for the job status transitions the admin UI
// can offer through the "Durum Güncelle" dropdown.
//
// Was inlined in JobDetail.js. Same drift-fix pattern as Sprint A's
// overdue helper and Sprint C.1's backend refactor — once you find
// yourself writing this map inline, you stop and import from here.
//
// Note on shape vs. backend: this map is intentionally narrower than
// backend/src/config/statusTransitions.js. The backend map is the
// full state machine; this map is "what the admin can pick from the
// status dropdown". Two specific UX divergences:
//
//   - pending -> assigned is NOT here. Admin assigns staff via the
//     "Personel" section in JobDetail, not the status dropdown.
//     Setting status='assigned' without an assigned_to via PATCH would
//     create an inconsistent row.
//   - paused (Sprint C.2) is reachable as a target only from mobile
//     (Sprint C.3) and not exposed via the status dropdown on web.
//     The transition is in the map below, but JobDetail filters it
//     out of the dropdown.

export const STATUS_TRANSITIONS = {
  pending:    ['cancelled'],
  assigned:   ['on_the_way', 'paused', 'cancelled'],
  on_the_way: ['started', 'paused', 'cancelled'],
  started:    ['completed', 'paused', 'cancelled'],
  paused:     ['assigned', 'cancelled'],
  completed:  ['approved'],
  approved:   [],
  cancelled:  [],
};

export function canTransition(fromStatus, toStatus) {
  const allowed = STATUS_TRANSITIONS[fromStatus] || [];
  return allowed.includes(toStatus);
}

export function allowedTransitions(fromStatus) {
  return STATUS_TRANSITIONS[fromStatus] || [];
}
